import { useCallback, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { REACT_APP_CAPTCHA_ENDPOINT } from '../../const';
import { AppContext } from '../../app-context';
import { useAnalyticsData } from '../hooks/use-update-analytics-data';

export const CAPTCHA_FIELD_NAME = 'captchaText';

export const useQuizCaptcha = () => {
  const [intakeId, setIntakeId] = useState('');
  const [recaptchaSiteKey, setRecaptchaSiteKey] = useState<string>();
  const [token, setToken] = useState('');
  const { updateAnalyticsData } = useAnalyticsData();

  const { setLoading } = useContext(AppContext);

  const refreshToken = useCallback(
    async (token?: string) => {
      axios.get(REACT_APP_CAPTCHA_ENDPOINT, {
        params: { intakeId },
        headers: {
          token,
        },
      });
      setToken(token);
      updateAnalyticsData({ abandonedField: 'captcha' }, intakeId);
    },
    [setToken, intakeId, updateAnalyticsData],
  );

  useEffect(() => {
    setLoading(true);
    axios
      .get(REACT_APP_CAPTCHA_ENDPOINT, { params: { intakeId: '' } })
      .then(res => {
        setRecaptchaSiteKey(res.data['reCaptchaSiteKey']);
        setIntakeId(res.data['intakeId']);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [setRecaptchaSiteKey, setIntakeId, setLoading]);

  return {
    recaptchaSiteKey,
    intakeId,
    token,
    refreshToken,
  };
};
